export const shouldHidePrice = (approvalStatus, storefrontShopSetting) => {
  return approvalStatus !== "approved" &&
  !storefrontShopSetting.shopShowItemPricing;
}
